<template lang="pug">
  .contentpage
    .header-area(v-if="areas.header && areas.header.length")
      section(v-for="(section, index) in areas.header" :key="section.id" :class="section.key" v-if="index === 0")
        Banner(v-if="section.key === 'banner'" :section="section")
        Slider(v-if="section.key === 'slider'" :section="section")
    .main-area(v-if="areas.main && areas.main.length")
      section(v-for="(section, index) in areas.main" :key="section.id" :class="section.key")
        Heading(v-if="section.key === 'heading'" :section="section")
        Post(v-if="section.key === 'post'" :section="section")
        Table(v-if="section.key === 'table'" :section="section")
        CategoryPosts(v-if="section.key === 'categoryposts'" :section="section")
        Swiper(v-if="section.key === 'swiper'" :section="section")
        Form(v-if="section.key === 'form'", :section="section")
</template>

<script>
import Page from '@/views/Page';

import Heading from '@/components/Heading';
import Slider from '@/components/Slider';
import Post from '@/components/Post';
import CategoryPosts from '@/components/CategoryPosts';
import Banner from '@/components/Banner';
import Swiper from '@/components/Swiper';
import Table from '@/components/Table';
import Form from '@/components/Form';

export default {
    name: 'ContentPage',
    extends: Page,
    components: {
        Heading,
        Slider,
        CategoryPosts,
        Post,
        Banner,
        Swiper,
        Table,
        Form
    }
};
</script>

<style lang="sass" scoped>
section.slider,
section.banners
  padding: 0
section.heading
  padding-bottom: 0
</style>
